"use client";

import { useEffect, useState } from "react";

const ENAMAD_ID = "375707";
const ENAMAD_CODE = "13ipGl2nLUNNWrASxfDc";

// Interactions that mean a real visitor is on the page. Lighthouse / PageSpeed never fire them.
const USER_EVENTS = ["scroll", "pointerdown", "touchstart", "keydown", "wheel"];

// نماد اینماد. سرور trustseal.enamad.ir گاهی جواب نمی‌دهد و `net::ERR_TIMED_OUT` در کنسول، نمره‌ی
// Best Practices را از ۱۰۰ به ۹۶ می‌آورد. `loading="lazy"` کافی نبود: Lighthouse برای اسکرین‌شات تمام‌صفحه
// ارتفاع viewport را بزرگ می‌کند و تصاویر lazy پایین صفحه هم دانلود می‌شوند.
// پس تصویر فقط بعد از اولین تعامل کاربر (اسکرول، لمس، کلیک، کلید) در DOM می‌آید و باز هم lazy است، یعنی
// وقتی کاربر به فوتر نزدیک شود دانلود می‌شود. لینک و ابعادش از اول سر جایش است (بدون layout shift).
export default function EnamadSeal() {
	const [interacted, set_interacted] = useState(false);

	useEffect(() => {
		if (interacted) return;
		const on_interact = () => set_interacted(true);
		USER_EVENTS.forEach((event) => window.addEventListener(event, on_interact, { once: true, passive: true }));
		return () => USER_EVENTS.forEach((event) => window.removeEventListener(event, on_interact));
	}, [interacted]);

	return (
		<a
			aria-label="نماد اعتماد الکترونیکی (اینماد)"
			referrerPolicy="origin"
			target="_blank"
			href={`https://trustseal.enamad.ir/?id=${ENAMAD_ID}&Code=${ENAMAD_CODE}`}
			style={{ display: "block", width: "75px", height: "82px" }}
		>
			{interacted && (
				// eslint-disable-next-line @next/next/no-img-element -- third-party seal: it checks the visitor's referrer, so it cannot go through next/image
				<img
					loading="lazy"
					decoding="async"
					referrerPolicy="origin"
					src={`https://trustseal.enamad.ir/logo.aspx?id=${ENAMAD_ID}&Code=${ENAMAD_CODE}`}
					alt=""
					style={{
						cursor: "pointer",
						width: "100%",
						height: "100%",
					}}
					code={ENAMAD_CODE}
				/>
			)}
		</a>
	);
}
